import { filter } from 'lodash'
import { addPromoData, addTaxablePriceToCartItems } from './cartItemsFormatter'

const createPromotionFormData = ({ cartItems, appliedPromotions, subtotal, shippingQuote }) => {
  const cartWithPromoData = addTaxablePriceToCartItems(cartItems)
  const cartForForm = addPromoData(cartWithPromoData, true)

  const formData = new FormData()
  const numberOfDiscountsApplied = filter(appliedPromotions, promo => promo.type === 'discount').length
  formData.append('applied_count', numberOfDiscountsApplied)
  formData.append('subtotal', subtotal)
  formData.append('shipping_cost', shippingQuote)
  formData.append('cart_items', JSON.stringify(cartForForm))

  return formData
}

// for discounts - needs applied promotion ids
export const createFetchDiscountsFormData = options => {
  const formData = createPromotionFormData(options)
  return formData
}

// skip fetching discounts if all prices are 0
export const shouldFetchDiscounts = ({ subtotal, shippingQuote }) => {
  const totalValue = (subtotal || 0) + (shippingQuote || 0)
  return totalValue > 0
}

// for coupons - needs coupon code
export const createFetchCouponFormData = options => {
  const formData = createPromotionFormData(options)
  formData.append('coupon_code', options.couponCode)
  return formData
}
